module.exports = __webpack_public_path__ + "static/tyr-symbol-SCAG-080685b58daa00a281999d38e1d78a2c.png";